var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibility = function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.176 65.04c10.414-4.101 15.532-15.868 11.431-26.282A20.21 20.21 0 0 0 69.17 27.325",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.226 58.918c7.233-2.848 10.787-11.02 7.94-18.253a14.037 14.037 0 0 0-7.944-7.941M24.824 65.04C14.41 60.939 9.292 49.172 13.393 38.758A20.21 20.21 0 0 1 24.83 27.325",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.774 58.918c-7.233-2.848-10.787-11.02-7.94-18.253a14.037 14.037 0 0 1 7.944-7.941M49.99 33.96h-5.98l-9.368 9.367v5.98l9.368 9.368h5.98l9.368-9.367v-5.98L49.99 33.96Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgVisibility;